/* mojave theme - v2.0.13 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function calcVHUnits() {
  document.documentElement.style.setProperty(
    '--viewport-height',
    `${window.innerHeight}px`
  );
}

['load', 'scroll', 'resize'].forEach((eventName) =>
  window.addEventListener(eventName, calcVHUnits)
);

function isIOS() {
  return (
    /iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test(
      navigator.platform
    ) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentElement.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function playYoutubeVideo(video) {
  if (!video.src.includes('enablejsapi=1')) return;

  video.contentWindow.postMessage(
    '{"event":"command","func":"' + 'playVideo' + '","args":""}',
    '*'
  );
}

function playAllYoutubeVideos() {
  const videos = document.querySelectorAll('.js-youtube');

  videos.forEach((video) => {
    playYoutubeVideo(video);
  });
}

window.addEventListener('load', () => {
  playAllYoutubeVideos();
});

/* prevent pinch zoom via touchpad */
document.addEventListener(
  'wheel',
  (event) => {
    const { ctrlKey } = event;
    if (ctrlKey) {
      event.preventDefault();
      return;
    }
  },
  { passive: false }
);

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.searchInput = this.querySelector('input[type="search"]');
    this.scrollContainer = this.querySelector('[data-scroll-container]');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector('summary')
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        detailsElement.closest('.menu-drawer__menu-js').style.height = '0px';
        detailsElement.closest('.menu-drawer__menu-js').style.overflow = 'hidden';
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            'transitionend',
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    bodyScrollLock.disableBodyScroll(this.scrollContainer);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    bodyScrollLock.enableBodyScroll(this.scrollContainer);
  }

  onFocusOut(event) {
    setTimeout(() => {
      const isPredictiveSearchOpened =
        this.searchInput?.classList?.contains('has-search-input') || null;

      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        !isPredictiveSearchOpened &&
        !this.searchInput.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
    detailsElement.closest('.menu-drawer__menu').removeAttribute('style');
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.scrollContainersInner = this.querySelectorAll(
      '[data-scroll-container-inner]'
    );
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section--header');
    this.borderOffset =
      this.borderOffset ||
        this.closest('.header-wrapper').classList.contains(
          'header--border-bottom'
        )
        ? 1
        : 0;

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');
    this.announcementBar = document.querySelector(
      '.section--announcement-bar:not(.section--header + .section--announcement-bar)'
    );
    this.announcementBarHeight = this.announcementBar
      ? this.announcementBar.offsetHeight -
      parseInt(getComputedStyle(this.announcementBar).paddingBottom)
      : 0;
    const hasPassedAnnouncementBar =
      window.scrollY > this.announcementBarHeight;
    const announcementBarExists = this.announcementBarHeight > 0;
    if (
      !announcementBarExists ||
      (announcementBarExists && hasPassedAnnouncementBar)
    ) {
      this.announcementBarOffset = 0;
    } else if (announcementBarExists && !hasPassedAnnouncementBar) {
      this.announcementBarOffset = this.announcementBarHeight - window.scrollY;
    }

    summaryElement.nextElementSibling.style.top = `${this.announcementBarOffset + this.header.offsetHeight
      }px`;

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    bodyScrollLock.disableBodyScroll(this.scrollContainer);
    this.scrollContainersInner.forEach((container) => {
      bodyScrollLock.disableBodyScroll(container);
    });
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    bodyScrollLock.enableBodyScroll(this.scrollContainer);
    this.scrollContainersInner.forEach((container) => {
      bodyScrollLock.enableBodyScroll(container);
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((button) => {
      button.addEventListener('click', this.hide.bind(this));
    });
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (
      this.moved ||
      (this.hasAttribute('data-prevent-move') && window.innerWidth >= 990) ||
      (this.hasAttribute('data-prevent-move-mobile') && window.innerWidth < 990)
    )
      return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    bodyScrollLock.disableBodyScroll(
      this.querySelector('[data-scroll-container]') ||
      this.querySelector('[role="dialog"] > *')
    );

    this.setAttribute('open', '');
    setTimeout(() => {
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }, 300);
  }

  hide() {
    bodyScrollLock.enableBodyScroll(
      this.querySelector('[data-scroll-container]') ||
      this.querySelector('[role="dialog"] > *')
    );
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);

    if (this.hasAttribute('data-remove-on-close')) {
      window.modals = window.modals || {};
      window.modals[this.id] = document.body.removeChild(this);
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );

      if (isIOS()) {
        deferredElement.controls = true;
      }

      deferredElement.play && deferredElement.play();

      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

const getOffsetTop = (element) => {
  let offsetTop = 0;

  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
  } while ((element = element.offsetParent));

  return offsetTop;
};

const isInViewport = (element) => {
  const windowBottom = window.pageYOffset + window.innerHeight;

  return windowBottom >= getOffsetTop(element);
};

document.querySelectorAll('[data-fade-in]').forEach((element) => {
  ['load', 'scroll', 'shopify:section:load'].forEach((eventName) => {
    window.addEventListener(eventName, () => {
      if (!isInViewport(element)) {
        return;
      }

      element.classList.add('fade-in');
    });
  });
});

function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }

  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  let nameEQ = name + '=';
  let ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}

/* constants */
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

function listRoleHandler(node) {
  if (node.getAttribute('role') == null) {
    node.setAttribute('role', 'list');
  }
}

// Accessibility 
function listRoleHandler(items, attribute, attribute_value) {
  items.forEach(listItem => {
    if (listItem.getAttribute(`${attribute}`) == null) {
      listItem.setAttribute(`${attribute}`, `${attribute_value}`);
    }
  });
}

(function () {
  let mutationTimer;

  // Helper to set attributes and mark element as processed
  const processBatch = (selector, attr, value) => {
    // Only select elements that haven't been processed yet
    const elements = document.querySelectorAll(`${selector}:not([data-a11y-processed])`);
    elements.forEach(el => {
      if (attr && value) el.setAttribute(attr, value);
      el.setAttribute('data-a11y-processed', 'true');
    });
  };

  const handleAccessibilityFixes = () => {
    // --- 1. Batch Role Assignments ---
    processBatch('.js-marquee', 'role', 'list');
    processBatch('.keen-slider', 'role', 'list');
    processBatch('.c-filtered-collection .slick-track', 'role', 'list');
    processBatch('.keen-slider__slide', 'role', 'listitem');
    processBatch('.junip-review-list-item-container', 'role', 'listitem');
    processBatch('.vw-cmp__in-video-card-button', 'aria-label', 'Play video');

    // --- 2. Complex Element Logic ---

    // Keen Slider Arrows
    document.querySelectorAll('.rw__swiper--carousel-btn:not([data-a11y-processed])').forEach(btn => {
      if (!btn.querySelector('span.sr-only')) {
        const span = document.createElement('span');
        span.className = 'sr-only';
        span.innerText = btn.classList.contains('rw__swiper-btn--next') ? 'Next button' : 'Prev button';
        btn.appendChild(span);
      }
      btn.setAttribute('data-a11y-processed', 'true');
    });

    // Junip Review Icons
    document.querySelectorAll('.junip-product-summary-star svg:not([data-a11y-processed])').forEach(svg => {
      svg.removeAttribute('role');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const title = svg.querySelector('title');
      if (title) title.remove();
      svg.setAttribute('data-a11y-processed', 'true');
    });

    // Junip Review Wrappers
    document.querySelectorAll('.junip-product-summary-star-ratings-container:not([data-a11y-processed])').forEach(wrapper => {
      if (wrapper.hasAttribute('role')) wrapper.removeAttribute('role');
      wrapper.setAttribute('data-a11y-processed', 'true');
    });

    // Country Search Buttons
    document.querySelectorAll('button[aria-label="Search Countries"][role="combobox"]:not([data-a11y-processed])').forEach(btn => {
      btn.removeAttribute('role');
      if (!btn.hasAttribute('aria-haspopup')) btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('data-a11y-processed', 'true');
    });

    // Interactive Buttons (Video Widget & Content Over)
    const interactiveSelector = '.vw-content-over[role="button"]:not([data-a11y-processed]), .vw-content-over div[role="button"]:not([data-a11y-processed])';
    document.querySelectorAll(interactiveSelector).forEach(btn => {
      if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');

      btn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          btn.click();
        }
      });
      btn.setAttribute('data-a11y-processed', 'true');
    });

    // VW Role Buttons
    const roleBtnSelector = '.vw-content-over div[role="button"]:not([data-a11y-processed]), .vw-cmp__in-video-card--root div[role="button"]:not([data-a11y-processed])';
    document.querySelectorAll(roleBtnSelector).forEach(btn => {
      if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          btn.click();
        }
      });
      btn.setAttribute('data-a11y-processed', 'true');
    });

    // VW Play Buttons
    document.querySelectorAll('.vw-cmp__in-video-card-button:not([data-a11y-processed])').forEach(btn => {
      if (btn.getAttribute('role') !== 'button') btn.setAttribute('role', 'button');
      if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          btn.click();
        }
      });
      btn.setAttribute('data-a11y-processed', 'true');
    });

    // Rebuy Compare Prices
    document.querySelectorAll('.rebuy-money.compare-at:not([data-a11y-processed])').forEach(el => {
      const visiblePrice = Array.from(el.children).find(span => !span.classList.contains('sr-only'));
      if (visiblePrice && !visiblePrice.hasAttribute('aria-label')) {
        visiblePrice.setAttribute('aria-label', 'Previous price');
      }

      if (!el.querySelector('.sr-only')) {
        const srSpan = document.createElement('span');
        srSpan.className = 'sr-only';
        srSpan.textContent = 'Original price';
        el.insertBefore(srSpan, visiblePrice);
      }
      el.setAttribute('data-a11y-processed', 'true');
    });

    // --- 3. Single Element Logic ---

    // Pixel Image
    const pixelImage = document.querySelector('img[src^="https://trkn.us/pixel"]:not([data-a11y-processed])');
    if (pixelImage) {
      if (!pixelImage.hasAttribute('alt')) pixelImage.setAttribute('alt', 'Pixel image');
      pixelImage.setAttribute('data-a11y-processed', 'true');
    }

    // Shopify Preview Iframe
    const shopifyPreviewIframe = document.querySelector('#PBarNextFrame:not([data-a11y-processed])');
    if (shopifyPreviewIframe) {
      shopifyPreviewIframe.setAttribute('aria-hidden', 'true');
      shopifyPreviewIframe.setAttribute('tabindex', '-1');
      shopifyPreviewIframe.setAttribute('data-a11y-processed', 'true');
    }

    // Junip Container
    const reviewAppContainer = document.querySelector('.junip-reviews-container:not([data-a11y-processed])');
    if (reviewAppContainer) {
      if (!reviewAppContainer.hasAttribute('role')) reviewAppContainer.setAttribute('role', 'list');
      reviewAppContainer.setAttribute('data-a11y-processed', 'true');
    }
  };

  // --- 4. Optimized Observer ---
  const observerDOM = new MutationObserver((mutations) => {
    let shouldRun = false;

    // Check if new nodes were actually added
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldRun = true;
        break;
      }
    }

    if (!shouldRun) return;

    // Debounce execution
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(() => {
      // Use requestIdleCallback to avoid blocking main thread
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => handleAccessibilityFixes());
      } else {
        handleAccessibilityFixes();
      }
    }, 200);
  });

  // Start observing
  observerDOM.observe(document.body, { childList: true, subtree: true });

  // Run once on load
  window.addEventListener('load', handleAccessibilityFixes);

})();

document.addEventListener("DOMContentLoaded", function () {
  const skipLinks = document.querySelectorAll(".skip-link");

  skipLinks.forEach((link) => {
    link.addEventListener("click", function () {
      const targetId = link.getAttribute("href");
      if (!targetId || targetId.charAt(0) !== "#") return;

      const target = document.querySelector(targetId);
      if (!target) return;

      // Give browser time to jump, then force focus
      setTimeout(() => {
        if (!target.hasAttribute("tabindex")) {
          target.setAttribute("tabindex", "-1");
        }
        target.focus({ preventScroll: true });
      }, 0);
    });
  });
});

if (!customElements.get('sticky-bar')) {
  class StickyBar extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      const targetClass = this.getAttribute('data-target-section') || '.video-info__section';
      const targetSection = document.querySelector(targetClass);

      if (!targetSection || !('IntersectionObserver' in window)) return;

      const options = {
        root: null,
        threshold: 0.1,
        rootMargin: '0px'
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            this.closest('.sticky-bar-bottom').classList.add('is--sticky');
          } else {
            this.closest('.sticky-bar-bottom').classList.remove('is--sticky');
          }
        });
      }, options);

      this.observer.observe(targetSection);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define('sticky-bar', StickyBar);
}

document.addEventListener('DOMContentLoaded', () => {
  const waitlistButtons = document.querySelectorAll('.waitlist-page-btn');

  if (waitlistButtons.length > 0) {
    waitlistButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const targetSection = document.querySelector('.video-info__section .info-container');
        if (targetSection) {
          e.preventDefault();

          const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = targetPosition - 150;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
});

const faqCustomBlocks = document.querySelectorAll('.accordion-inner.faq-logic-enabled');

faqCustomBlocks.forEach(item => {
  const itemsMax = parseInt(item.getAttribute('data-items-to-show-initially'));
  const content = item.querySelector('.c-faq-content');
  const viewMoreWrapper = item.querySelector('.c-view-more-button');
  const viewMoreButton = item.querySelector('.view-more-btn');
  const accordionContent = item.closest('.accordion-content');

  if (content && !isNaN(itemsMax) && viewMoreButton) {
    const questions = content.querySelectorAll('h3');
    const answers = content.querySelectorAll('p');

    if (questions.length <= itemsMax) {
      if (viewMoreWrapper) viewMoreWrapper.style.display = 'none';
      return;
    }

    const updateAccordionHeight = () => {
      if (accordionContent) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      }
    };

    const toggleVisibility = (isExpanded) => {
      questions.forEach((question, index) => {
        if (index >= itemsMax) {
          const displayStyle = isExpanded ? 'block' : 'none';
          question.style.display = displayStyle;
          if (answers[index]) answers[index].style.display = displayStyle;
        }
      });

      const { moreText, lessText } = viewMoreWrapper.dataset;
      viewMoreButton.textContent = isExpanded ? lessText : moreText;
      viewMoreWrapper.setAttribute('data-expanded', isExpanded);

      requestAnimationFrame(() => {
        updateAccordionHeight();
      });
    };

    toggleVisibility(false);

    viewMoreButton.addEventListener('click', () => {
      const isCurrentlyExpanded = viewMoreWrapper.getAttribute('data-expanded') === 'true';
      toggleVisibility(!isCurrentlyExpanded);
    });
  }
});

const fixComparisonTables = () => {
  const tableWrappers = document.querySelectorAll('.product-compare-table-wrapper');

  tableWrappers.forEach((wrapper) => {
    wrapper.setAttribute('role', 'table');

    const tableBody = wrapper.querySelector('.product-compare-table-elem');
    if (!tableBody) return;
    tableBody.setAttribute('role', 'rowgroup');

    const rows = tableBody.querySelectorAll('.table-row-custom');

    rows.forEach((row, rowIndex) => {
      row.setAttribute('role', 'row');

      const cells = row.querySelectorAll('.table-row-item');

      cells.forEach(cell => {
        const innerContainer = cell.querySelector('.table-row-item-inner');

        if (rowIndex === 0) {
          cell.setAttribute('role', 'columnheader');
        } else {
          if (innerContainer && innerContainer.classList.contains('is--main-column')) {
            cell.setAttribute('role', 'rowheader');
          } else {
            cell.setAttribute('role', 'cell');
          }
        }
      });
    });
  });
};

fixComparisonTables();

const parseStyledSymbols = (rawValue) => {
  if (typeof rawValue !== 'string') return [];

  return rawValue
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);
};

const shouldSkipSymbolWrapNode = (node, symbols) => {
  if (!node || !node.nodeValue) return true;
  if (!symbols.length) return true;
  if (!symbols.some((symbol) => node.nodeValue.includes(symbol))) return true;

  const parent = node.parentElement;
  if (!parent) return true;

  return Boolean(
    parent.closest(
      'sup.global-styled-symbol, script, style, noscript, textarea, pre, code, svg, math, select, option, title, [data-no-symbol-wrap="true"]'
    )
  );
};

const findNearestSymbolMatch = (value, symbols) => {
  let winner = null;

  symbols.forEach((symbol) => {
    const index = value.indexOf(symbol);
    if (index < 0) return;

    if (!winner || index < winner.index || (index === winner.index && symbol.length > winner.symbol.length)) {
      winner = { index, symbol };
    }
  });

  return winner;
};

const wrapConfiguredSymbolsInNode = (rootNode, symbols) => {
  if (!rootNode || !symbols.length) return;

  const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT);
  const textNodes = [];

  while (walker.nextNode()) {
    const currentNode = walker.currentNode;
    if (!shouldSkipSymbolWrapNode(currentNode, symbols)) {
      textNodes.push(currentNode);
    }
  }

  textNodes.forEach((textNode) => {
    const value = textNode.nodeValue;
    if (!value) return;

    const fragment = document.createDocumentFragment();
    let remaining = value;

    while (remaining.length > 0) {
      const match = findNearestSymbolMatch(remaining, symbols);

      if (!match) {
        fragment.appendChild(document.createTextNode(remaining));
        break;
      }

      if (match.index > 0) {
        fragment.appendChild(document.createTextNode(remaining.slice(0, match.index)));
      }

      const symbolElement = document.createElement('sup');
      symbolElement.className = 'global-styled-symbol';
      symbolElement.textContent = match.symbol;
      fragment.appendChild(symbolElement);

      remaining = remaining.slice(match.index + match.symbol.length);
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  });
};

const GLOBAL_STYLED_SYMBOLS_STATE_KEY = '__globalStyledSymbolsState';

const initializeGlobalStyledSymbols = () => {
  const styledSymbolsSettings = window.theme?.settings?.styledSymbols;
  const enabled = Boolean(styledSymbolsSettings?.enabled);
  const symbols = parseStyledSymbols(styledSymbolsSettings?.characters || '');

  if (!enabled || !symbols.length) return;

  const state = window[GLOBAL_STYLED_SYMBOLS_STATE_KEY] || {};
  if (state.initialized) {
    state.symbols = symbols;
    state.scheduleRun(document.body);
    return;
  }

  state.initialized = true;
  state.symbols = symbols;
  state.observerTimer = null;
  state.observedBody = null;
  state.pendingRoot = null;

  state.run = (root = document.body) => {
    if (!root || !state.symbols?.length) return;
    const normalizedRoot = root.nodeType === Node.TEXT_NODE ? root.parentElement : root;
    if (!normalizedRoot) return;
    wrapConfiguredSymbolsInNode(normalizedRoot, state.symbols);
  };

  state.scheduleRun = (root = document.body) => {
    if (root) {
      state.pendingRoot = root;
    }

    clearTimeout(state.observerTimer);
    state.observerTimer = setTimeout(() => {
      state.run(state.pendingRoot || document.body);
      state.pendingRoot = null;
    }, 80);
  };

  state.observeBody = () => {
    if (!document.body) return;

    if (state.bodyObserver) {
      state.bodyObserver.disconnect();
    }

    state.observedBody = document.body;
    state.bodyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((addedNode) => {
          if (addedNode.nodeType === Node.TEXT_NODE) {
            state.scheduleRun(addedNode.parentElement);
            return;
          }

          if (addedNode.nodeType === Node.ELEMENT_NODE) {
            state.scheduleRun(addedNode);
          }
        });
      });
    });

    state.bodyObserver.observe(document.body, { childList: true, subtree: true });
  };

  state.documentObserver = new MutationObserver(() => {
    if (document.body && state.observedBody !== document.body) {
      state.observeBody();
      state.scheduleRun(document.body);
    }
  });
  state.documentObserver.observe(document.documentElement, { childList: true });

  if (!state.historyPatched) {
    state.historyPatched = true;

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function () {
      const result = originalPushState.apply(this, arguments);
      state.scheduleRun(document.body);
      setTimeout(() => state.scheduleRun(document.body), 250);
      return result;
    };

    history.replaceState = function () {
      const result = originalReplaceState.apply(this, arguments);
      state.scheduleRun(document.body);
      setTimeout(() => state.scheduleRun(document.body), 250);
      return result;
    };
  }

  const rerunEvents = [
    'shopify:section:load',
    'shopify:section:reorder',
    'shopify:block:select',
    'shopify:block:deselect',
    'compliance:content-swapped',
    'global-styled-symbols:run',
    'compliance:content-swapped',
  ];

  rerunEvents.forEach((eventName) => {
    window.addEventListener(eventName, (event) => {
      state.scheduleRun(event?.target || document.body);
    });
  });

  window.addEventListener('pageshow', () => state.scheduleRun(document.body));
  window.addEventListener('popstate', () => state.scheduleRun(document.body));
  window.addEventListener('hashchange', () => state.scheduleRun(document.body));

  window.runGlobalStyledSymbols = (root) => {
    state.scheduleRun(root || document.body);
  };

  state.observeBody();
  state.scheduleRun(document.body);

  window[GLOBAL_STYLED_SYMBOLS_STATE_KEY] = state;
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeGlobalStyledSymbols);
} else {
  initializeGlobalStyledSymbols();
}

const cards = document.querySelectorAll('.cp-card.has--flavor-selection');

cards.forEach(card => {
  const flavors = card.querySelectorAll('.cp-card__flavor-item');
  const images = card.querySelectorAll('.cp-card__image-link');
  const headingLink = card.querySelector('.cp-card__title a');
  const actionLink = card.querySelector('.cp-card__actions a');

  const setActiveFlavor = (handle) => {
    let activeImage = null;

    // toggle images
    images.forEach(img => {
      const isMatch = img.dataset.handle === handle;

      img.style.display = isMatch ? 'block' : 'none';
      img.classList.toggle('is--selected', isMatch);

      if (isMatch) activeImage = img;
    });

    // toggle flavors
    flavors.forEach(flavor => {
      const isMatch = flavor.dataset.handle === handle;
      flavor.classList.toggle('is--selected', isMatch);
    });

    // update links
    if (activeImage) {
      const href = activeImage.getAttribute('href');

      if (headingLink) headingLink.href = href;
      if (actionLink) actionLink.href = href;
    }
  };

  // bind events
  flavors.forEach(flavor => {
    flavor.addEventListener('click', () => {
      setActiveFlavor(flavor.dataset.handle);
    });
  });

  // init default
  const defaultFlavor = card.querySelector('.cp-card__flavor-item.is--selected');
  if (defaultFlavor) {
    setActiveFlavor(defaultFlavor.dataset.handle);
  }
});

let isProgrammaticClick = false;
let lastGroupSelector = null;

document.body.addEventListener('click', (e) => {
  if (isProgrammaticClick) return;

  const trigger = e.target.closest('.purchase-option.is--add-one-time-to-subscription');
  if (!trigger) return;

  const configs = [
    {
      groupSelector: '.onetime-group',
      tabSelector: '.purchase-options__tab-nav--onetime',
    },
    {
      groupSelector: '.subscription-group',
      tabSelector: '.purchase-options__tab-nav--subscription',
    },
  ];

  for (const { groupSelector, tabSelector } of configs) {
    const group = e.target.closest(groupSelector);
    if (!group) continue;

    const tab = document.querySelector(`.purchase-options__tab-nav${tabSelector}`);
    const label = group.querySelector('label');

    if (tab && label) {
      const isSameGroup = lastGroupSelector === groupSelector;

      isProgrammaticClick = true;

      tab.click();

      setTimeout(() => {
        label.click();

        if (!isSameGroup) {
          document.body.style.pointerEvents = 'none';
        }

        setTimeout(() => {
          isProgrammaticClick = false;

          if (!isSameGroup) {
            document.body.style.pointerEvents = 'initial';
          }

          lastGroupSelector = groupSelector;
        }, 300);
      }, 200);
    }

    break;
  }
});

document.addEventListener('DOMContentLoaded', async () => {
  const MAX_DISCOUNT_ATTEMPTS = 3;
  const DISCOUNT_RETRY_DELAY = 250;
  const normalize = (value) => (value || '').trim().toLowerCase();
  const routeRoot = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams(window.location.search);
  const discountCode = params.get('discount')?.trim();

  if (!discountCode) return;

  const wait = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

  const fetchCart = async () => {
    const response = await fetch(`${routeRoot}cart.js`, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Cart fetch failed: ${response.status}`);
    }

    return response.json();
  };

  const getAppliedDiscountCodes = (cart) => [
    ...(cart.cart_level_discount_applications || []).map((item) =>
      normalize(item.title || item.discount_application?.title)
    ),
    ...(cart.discount_codes || [])
      .filter((item) => item.applicable !== false)
      .map((item) => normalize(item.code)),
  ];

  const buildDiscountString = (cart, code) => {
    const normalizedCodes = new Set();

    return [
      ...(cart.cart_level_discount_applications || []).map((item) =>
        item.title || item.discount_application?.title
      ),
      ...(cart.discount_codes || []).map((item) => item.code),
      code,
    ]
      .filter(Boolean)
      .filter((item) => {
        const normalizedCode = normalize(item);

        if (normalizedCodes.has(normalizedCode)) return false;

        normalizedCodes.add(normalizedCode);
        return true;
      })
      .join(',');
  };

  const updateDiscounts = async (cart, code) => {
    const formData = new FormData();
    formData.append('discount', buildDiscountString(cart, code));

    const response = await fetch(`${routeRoot}cart/update.js`, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Discount update failed: ${response.status}`);
    }

    return response.json();
  };

  const normalizedDiscountCode = normalize(discountCode);

  try {
    for (let attempt = 1; attempt <= MAX_DISCOUNT_ATTEMPTS; attempt += 1) {
      const cart = await fetchCart();

      if (getAppliedDiscountCodes(cart).includes(normalizedDiscountCode)) {
        return;
      }

      const updatedCart = await updateDiscounts(cart, discountCode);

      if (getAppliedDiscountCodes(updatedCart).includes(normalizedDiscountCode)) {
        return;
      }

      if (attempt < MAX_DISCOUNT_ATTEMPTS) {
        await wait(DISCOUNT_RETRY_DELAY * attempt);
      }
    }

    console.warn('Auto discount was submitted but not applied:', discountCode);
  } catch (error) {
    console.error('Auto discount apply error:', error);
  }
});

document.addEventListener('DOMContentLoaded', () => {

  class BeforeAfter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSliders();
      this.initReadMore();
    }

    initReadMore() {
      this.querySelectorAll('.before-after__read-more').forEach((button) => {
        button.addEventListener('click', () => {
          const content = button.closest('.before-after__content');
          if (!content) return;

          const shortContent = content.querySelector('.before-after__content-short');
          const fullContent = content.querySelector('.before-after__content-full');
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          const nextExpanded = !isExpanded;

          shortContent.hidden = nextExpanded;
          fullContent.hidden = !nextExpanded;
          button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
          button.textContent = nextExpanded
            ? button.dataset.lessText
            : button.dataset.moreText;
        });
      });
    }

    initSliders() {
      const thumbsEl = this.querySelector('.swiper-thumb.swiper');
      const mainEl = this.querySelector('.swiper-main.swiper');
      const thumbWrap = this.querySelector('.swiper-thumn-wrap');
      const mainWrap = this.querySelector('.swiper-main-wrap');
      const mobileNavQuery = window.matchMedia('(max-width: 989px)');

      if (!thumbsEl || !mainEl || !thumbWrap || !mainWrap) return;

      const getNavWrap = () => (mobileNavQuery.matches ? thumbWrap : mainWrap);

      let isSyncing = false;

      // THUMBS
      const thumbsSwiper = new Swiper(thumbsEl, {
        watchSlidesProgress: true,
        slideToClickedSlide: true,

        breakpoints: {
          1: {
            slidesPerView: 3,
            spaceBetween: 25
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30
          }
        },

        on: {
          slideChange(swiper) {
            const index = swiper.activeIndex;

            isSyncing = true;
            mainSwiper.slideTo(index);
            setActive(index);
            isSyncing = false;
          },

          click(swiper) {
            const index = swiper.clickedIndex;
            if (index === undefined) return;

            isSyncing = true;
            mainSwiper.slideTo(index);
            setActive(index);
            isSyncing = false;
          }
        }
      });

      // MAIN
      const mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,

        navigation: {
          prevEl: getNavWrap().querySelector('.swiper-button-prev'),
          nextEl: getNavWrap().querySelector('.swiper-button-next'),
        },

        on: {
          slideChange(swiper) {
            if (isSyncing) return;

            const index = swiper.activeIndex;

            isSyncing = true;
            thumbsSwiper.slideTo(index);
            setActive(index);
            isSyncing = false;
          }
        }
      });

      const updateNavigation = () => {
        const wrap = getNavWrap();
        mainSwiper.params.navigation.prevEl = wrap.querySelector('.swiper-button-prev');
        mainSwiper.params.navigation.nextEl = wrap.querySelector('.swiper-button-next');
        mainSwiper.navigation.destroy();
        mainSwiper.navigation.init();
        mainSwiper.navigation.update();
      };

      mobileNavQuery.addEventListener('change', updateNavigation);

      function setActive(index) {
        const slides = thumbsEl.querySelectorAll('.swiper-slide');

        slides.forEach((slide, i) => {
          slide.classList.toggle('swiper-slide-active', i === index);
        });
      }

      // init state
      setActive(0);
    }
  }

  customElements.define('before-after', BeforeAfter);

  
  if (document.body.classList.contains('product-bloat-gummy') || 
    document.body.classList.contains('product-bloat-gummy-v2') ||
    document.body.classList.contains('product-bloat-gummy-v3') ||
    document.body.classList.contains('product-bloat-gummy-v4')) {
    (() => {
      const mainContent = document.getElementById('MainContent');

      if (!mainContent) {
        console.warn('#MainContent not found');
        return;
      }

      let updatedCount = 0;

      for (const element of mainContent.querySelectorAll('*')) {
        if (getComputedStyle(element).fontFamily.includes('Cardinal Fruit')) {
          element.style.setProperty('transition', 'letter-spacing 0.3s', 'important');
          element.style.setProperty('letter-spacing', '-1px', 'important');
          updatedCount++;
        }
      }
    })();
  }

  const cartDrawer = document.querySelector('cart-drawer.cart-drawer');

  if (!cartDrawer) return;

  const updateCartDrawerAccessibility = () => {
    const isActive = cartDrawer.classList.contains('active');

    if (isActive) {
      cartDrawer.removeAttribute('inert');
      cartDrawer.removeAttribute('aria-hidden');
    } else {
      cartDrawer.setAttribute('inert', '');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
  };

  updateCartDrawerAccessibility();

  const observer = new MutationObserver(updateCartDrawerAccessibility);

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class']
  });
});